(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/lobby/assets/javascripts/lobby.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/lobby/assets/javascripts/lobby.js');
"use strict";


const {
  lazy
} = svs.components.lbUtils.lazy;
const {
  Route,
  Switch
} = ReactRouterDOM;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useContext,
  useCallback
} = React;
const {
  closeDialogAction
} = svs.components.marketplaceCompetition.services.actions.dialogActions;
const {
  DialogWrapper
} = svs.components.marketplaceShared.dialogWrapper;
const {
  WidgetArea
} = svs.components.lbUtils.widgetArea;
const {
  RouteResult
} = svs.components.marketplaceCompetition.routeResult;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const {
  CompetitionMenuContext
} = svs.components.marketplaceCompetition.competitionMenu;
const {
  OverviewHero
} = svs.components.marketplaceCompetition.overviewHero;
const {
  LobbyFallback
} = svs.components.marketplaceCompetition.lobby;
const AboutPage = () => {
  const {
    competitionMenu
  } = useContext(CompetitionMenuContext);
  return React.createElement(React.Fragment, null, React.createElement(OverviewHero, null), React.createElement("span", {
    className: "competition-overflow-up"
  }, competitionMenu), React.createElement(WidgetArea, {
    className: "bg-white",
    widgetArea: "tipssmInfoWidgetArea"
  }));
};
const Invite = lazy('/cl/marketplace-competition/react:team-invitation', () => svs.components.marketplaceCompetition.teamInvitation.TeamInvitation, {
  fallback: LobbyFallback
});
const CreateTeam = lazy('/cl/marketplace-competition/react:create-team', () => svs.components.marketplaceCompetition.createTeam.CreateTeam, {
  fallback: LobbyFallback
});
const OverView = lazy('/cl/marketplace-competition/react:overview', () => svs.components.marketplaceCompetition.overview.OverView, {
  fallback: LobbyFallback
});
const TeamPage = lazy('/cl/marketplace-competition/react:team-page', () => svs.components.marketplaceCompetition.teamPage.TeamPage, {
  fallback: LobbyFallback
});
const CurrentTeamView = _ref => {
  let {
    props
  } = _ref;
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  return isSmall ? React.createElement(TeamPage, props) : React.createElement(OverView, props);
};
const Dialogs = () => {
  const dialogInfo = useSelector(state => state.Competition.Dialog);
  const dispatch = useDispatch();
  const onClose = useCallback(() => {
    dispatch(closeDialogAction());
  }, [dispatch]);
  return React.createElement(DialogWrapper, {
    dialogInfo: dialogInfo,
    onClose: onClose
  });
};
const Lobby = () => {
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const createTeamView = isSmall ? CreateTeam : OverView;
  return React.createElement("div", {
    className: "competition lobby"
  }, React.createElement(Dialogs, null), React.createElement(Switch, null, React.createElement(Route, {
    component: createTeamView,
    path: "/tavlingar/:competitionName/skapa-lag"
  }), React.createElement(Route, {
    component: RouteResult,
    path: "/tavlingar/:competitionName/resultat"
  }), React.createElement(Route, {
    component: Invite,
    path: "/tavlingar/:competitionName/lag/:teamId/bjud-in"
  }), React.createElement(Route, {
    component: AboutPage,
    path: "/tavlingar/:competitionName/om"
  }), React.createElement(Route, {
    component: CurrentTeamView,
    path: "/tavlingar/:competitionName/lag/:teamId"
  }), React.createElement(Route, {
    component: OverView,
    path: "/tavlingar/:competitionName/join/:encodedLink"
  }), React.createElement(Route, {
    component: OverView
  })));
};
setGlobal('svs.components.marketplaceCompetition.lobby.Lobby', Lobby);

 })(window);